import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useMessageBus } from "@jti/fe-message-bus";
import { CircleLoader } from "../../../../components/CircleLoader";
import { LoadMore } from "../../../../components/LoadMore";
import { SearchCard } from "../SearchCard";
import { useSearch } from "./useSearch";
import styles from "./SearchResults.module.scss";
export const SearchResults = ({ translations, searchType, locale, loadResultsPerPage = 10, }) => {
    const { isLoading, searchText, searchResponse, loadMoreHandler } = useSearch({
        type: searchType,
        locale,
    });
    const messageBus = useMessageBus();
    const isShowLoadMoreButton = !isLoading && searchResponse?.data?.length > 0 && searchResponse?.data?.length < searchResponse?.meta?.total;
    const loadMoreNumber = searchResponse?.meta?.total - searchResponse?.meta?.to;
    const searchData = searchResponse?.data ?? [];
    useEffect(() => {
        if (searchText) {
            messageBus.publish("tracking.event", {
                payload: {
                    event_name: searchType === "faq" ? "faq_search" : "search",
                    additionalData: {
                        search_term: searchText,
                    },
                },
            });
        }
    }, [messageBus, searchText, searchType]);
    if (!searchText) {
        return null;
    }
    return (_jsxs("div", { className: styles.searchContainer, children: [isLoading && searchData.length === 0 && (_jsx("div", { className: styles.mainLoader, children: _jsx(CircleLoader, {}) })), _jsx("div", { className: styles.searchResultsContainer, children: searchData.map((card) => (_jsx(SearchCard, { img: card.thumbnail, title: card.title, description: card.content.body, linkLabel: translations.readMoreLabel, link: card.url, searchType: searchType, searchValue: searchText }, card.item_id))) }), searchData.length === 0 && !isLoading && (_jsx("div", { className: styles.noResults, "data-testid": "searchNoResults", children: translations.noResultsLabel })), isShowLoadMoreButton && (_jsx(LoadMore, { onClick: loadMoreHandler, "data-testid": "loadMoreButton", className: styles.loadMore, label: translations.loadMoreLabel?.replace("{0}", String(loadMoreNumber >= loadResultsPerPage ? loadResultsPerPage : loadMoreNumber)) })), isLoading && searchData.length > 0 && (_jsx("div", { className: styles.loadMoreLoaderContainer, children: _jsx(CircleLoader, {}) }))] }));
};
//# sourceMappingURL=SearchResults.js.map